module.exports = __webpack_public_path__ + "static/img/pic_pico04@2x.fe32679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_pico04@2x.png
// module id = 9H8C
// module chunks = 0